import React from 'react';
import { Box } from '@mui/material';

function AttendanceMiniTimeline({ workerStartMinutes, workerEndMinutes }) {
    const totalMinutes = 24 * 60;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const leftOffset = (workerStartMinutes / totalMinutes) * 100;
    const barWidth = workerEndMinutes !== null
        ? ((workerEndMinutes - workerStartMinutes) / totalMinutes) * 100
        : ((currentMinutes - workerStartMinutes) / totalMinutes) * 100;

    return (
        <Box sx={{ position: 'relative', height: '4px', backgroundColor: '#e0e0e0', borderRadius: '2px', width: '100%' }}>
            <Box sx={{
                position: 'absolute',
                left: `${leftOffset}%`,
                top: 0,
                height: '4px',
                width: `${Math.max(barWidth, 0)}%`,
                backgroundColor: workerEndMinutes === null ? '#43a047' : '#5d4037',
                borderRadius: '2px',
            }} />
        </Box>
    );
}

export default AttendanceMiniTimeline;
